module.exports = __webpack_public_path__ + "ipetbooking/admin/img/piggy-bank.e075d14d.svg";